// 项目接口文档
// import axios from './axios.js'
import url from './link.js'
import axios from '../../../utils/http'


let onlinePay = url.orderCreate

/**
 * 接口路径
 */
const api = {
  // 个人云登录文档：http://doc.whkso.com/account/signin.html
  getUser200 () {
    return axios.post('https://account.wps.com/p/auth/check')
  },
  /**
   * @param {*} 创建订单必填字段
   * orderParams = {
   *  pay_way: string               //支付方式
   *  source: string  require                //来源
   *  client_version: string        //客户端版本号
   *  client: string                //客户端
   *  order_type: int               //订阅类型(1: 一次支付，2：订阅)
   *  channel: string               //渠道
   *  language: string              //语言
   *  platform: string              //平台
   *  req_param: string             //额外参数，由pay_way决定参数格式
   *  cart_infos: object            //购物车
   *             {
   *               sku_id: string require // 商品ID
   *               sku_type  // 商品类型 1表示一次性购买，2表示订阅商品
   *               sku_name string require// 商品名称
   *               sku_count // 数量
   *             }
   *  client_id: string             //业务分配的唯一ID
   * }
   */
  createOrder (params) {
    let orderParams = {
      pay_way: 'PC_2CHECKOUT_INLINE',
      source: params.source,
      client_version: '',
      client: '',
      order_type: 2,
      channel: params.channel || 'normal',
      language: '',
      platform: 'PC',
      client_id: 'PC_SERVICE_ID',
      req_param: JSON.stringify({
        auto_renewal: true,
        currency: 'USD'
      }),
      cart_infos: [
        {
          sku_id: params.productId, // 商品ID
          sku_type: 2, // 商品类型 1表示一次性购买，2表示订阅商品
          sku_name: params.productName, // 商品名称
          sku_count: 1 // 数量
        }
      ]
    }
    return axios.post(onlinePay, orderParams)
  },
  /**
   *
   * @param {*} params 创建订阅接口
   * params = {
   *  subscribe_url: string, require       //avangate api地址
   *  order_id：string, require           //定单id
   * }
   */
  subscription (params) {
    let orderId = {
      order_id: params.order_id
    }
    return axios.post(params.subscribe_url, orderId)
  },
  /**
   *
   * 查询用户是哪种会员
   * 测试配置hosts：52.43.208.109 store.wps.com
   */
  checkVip () {
    return axios.get('https://store.wps.com/api/v3/user/query/wps_vips')
  },
  // 用户的优惠码列表
  getUserCoupons (params) {
    return axios.get(`/promo-code-server/promocodes`, {
      params: params
    })
  },
  // 用户的某一个优惠码（根据活动ID）
  getActivityCoupon (params) {
    return axios.get(`/promo-code-server/activity/promocode`, {
      params: params
    })
  },
  // 发放优惠码
  codedeLivery (params) {
    return axios.get(`/promo-code-server/promocodedelivery`, {
      params: params
    })
  },
  // 用户的某一个优惠码（根据优惠码ID）获取码对应信息
  codeInfo (params) {
    return axios.get(`/promo-code-server/promocode`, {
      params: params
    })
  },
  // 获取活动的有效性
  activityValidity (params) {
    return axios.get(`/promo-code-server/activity/validity`, {
      params: params
    })
  },
  // 更新优惠码为使用状态
  usedCode (params) {
    return axios.post(`/promo-code-server/promocodeupdate`, params)
  },
  // 数仓打点
  sendDw (category, item, action, vas_source, itemType, skuId) {
    // 数仓打点
    dw.onEvent('vas_activity_sales', {
      sale_name: 'christmas2019',
      category,
      item,
      action,
      vas_source,
      item_type: itemType || null,
      sku_id: skuId || null
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/modules/christmasPC-2019/plugins/api.js